import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}
  transform(html: string, length: number,type: string = 'characters'): SafeHtml {
    let truncatedHtml
    if (type === 'desc') {
      const newDiv = document.createElement('div')
      newDiv.innerHTML = html;
     truncatedHtml = this.truncate(newDiv.innerText, length);
    }
    else{
       truncatedHtml = this.truncate(html, length);
    }
   
    // return this.sanitizer.bypassSecurityTrustHtml(truncatedHtml);
    return truncatedHtml;
  }

  public truncate(input_text: string, length: number): string {
    input_text=input_text.toString()
    if (input_text.length <= length) {
      return input_text;
    }
    else{
      const truncated = input_text.slice(0, length);
      return truncated + '...';
    }
    }
   

}
